import React from "react";
import Image from "next/image";
import { AspectRatio } from "@chakra-ui/react";
import { ChakraBox } from "ui/chakra-framer";
import { AnimatePresence } from "framer-motion";
import { type AccordionItemProps } from ".";

export function AnimatedImage({ image, imageAlt, customFigure, label }: AccordionItemProps) {
  return (
    <AspectRatio
      ratio={5 / 4}
      pos="relative"
      bgGradient="linear(-45deg, oceanGradientLight, oceanGradientDark)"
      borderRadius="md"
      w="100%"
      overflow="hidden"
    >
      <AnimatePresence>
        <ChakraBox
          key={label}
          p={{ base: 6, lg: 9 }}
          initial={{
            opacity: 0,
            y: -250,
          }}
          animate={{
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.25,
              delay: 0.25,
            },
          }}
          exit={{
            opacity: 0,
            y: 250,
            transition: {
              duration: 0.3,
            },
          }}
        >
          {image && (
            <AspectRatio ratio={5 / 4} pos="relative" w="100%">
              <Image
                // Preloading: even though those these aren't above the fold, the lazyLoad lag takes away from animation transitions.
                priority
                fill
                src={image}
                alt={imageAlt ?? label}
                sizes="100%"
                style={{ objectFit: "contain", borderRadius: "6px" }}
              />
            </AspectRatio>
          )}

          {customFigure && customFigure}
        </ChakraBox>
      </AnimatePresence>
    </AspectRatio>
  );
}
